import React, { useEffect } from "react";
import { Container, Typography, Button, Box } from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    textAlign: "center",
    backgroundColor: "#f8f8f8",
  },
  icon: {
    fontSize: "6rem",
    color: theme.palette.error.main,
  },
  title: {
    marginTop: theme.spacing(2),
    fontWeight: 600,
    fontSize: "2rem",
  },
  description: {
    color: "#666",
    marginBottom: theme.spacing(4),
    fontSize: "1.1rem",
  },
  button: {
    padding: theme.spacing(1.5, 4),
    fontSize: "1rem",
    backgroundColor: theme.palette.error.main,
    color: "#fff",
    "&:hover": {
      backgroundColor: theme.palette.error.dark,
    },
  },
}));

const AuthErrorPage = () => {
  const classes = useStyles();

  const handleGoBack = () => {
    window.location.href = "/";
  };
  const controller = new AbortController();
  useEffect(() => {
    controller.abort(); // Cleanup if the component unmounts
  });

  return (
    <Container className={classes.root}>
      <ErrorOutlineIcon className={classes.icon} />
      <Typography variant="h4" className={classes.title}>
        Authentication Error
      </Typography>
      <Typography className={classes.description}>
        You are not authorized to view this page.
      </Typography>
      <Button className={classes.button} onClick={handleGoBack}>
        Go Back to Home
      </Button>
    </Container>
  );
};

export default AuthErrorPage;
